import { render, staticRenderFns } from "./HomeServiceInfoCard.vue?vue&type=template&id=0fc0cd42&"
import script from "./HomeServiceInfoCard.vue?vue&type=script&lang=js&"
export * from "./HomeServiceInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports